import { render } from "./DataScienceComponent.vue?vue&type=template&id=54c06eec&scoped=true"
import script from "./DataScienceComponent.vue?vue&type=script&lang=js"
export * from "./DataScienceComponent.vue?vue&type=script&lang=js"

import "./DataScienceComponent.vue?vue&type=style&index=0&id=54c06eec&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c06eec"]])

export default __exports__